import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import type { OrderingGuestCount } from "../../../../api/configuration";

/**
 * Мини-скица „Поток на масата" под настройката „Въвеждане на брой гости":
 * стъпките на масата като чипове, а „Брой гости" (кехлибарен) стои там,
 * където се пита — преди модала „Нова маса" или преди „Закрий". При „Не"
 * стъпката я няма. Само форми, без данни.
 */
export function GuestCountFlowIllustration({
  value,
}: {
  value: OrderingGuestCount;
}) {
  const { t } = useTranslation();
  const guests = { key: "guests", label: t("ordering.guestCount.title") };
  const newTable = { key: "newTable", label: t("ordering.newTable") };
  const order = { key: "order", label: t("orderingSettings.illustrationOrder") };
  const close = { key: "close", label: t("ordering.closeTable") };
  const steps =
    value === "new_table"
      ? [guests, newTable, order, close]
      : value === "close"
        ? [newTable, order, guests, close]
        : [newTable, order, close];

  return (
    <div
      className="mt-3 inline-flex max-w-full flex-col rounded-[10px] border border-shade-2 bg-panel p-2.5"
      aria-hidden
    >
      <div className="flex flex-wrap items-center gap-1.5">
        {steps.map((step, index) => (
          <Fragment key={step.key}>
            {index > 0 && <span className="text-[11px] text-muted">›</span>}
            <span
              className={`inline-flex h-6 items-center rounded-[6px] px-2 text-[10.5px] font-bold ${
                step.key === "guests"
                  ? "bg-brand text-white"
                  : "bg-fill-2 text-body"
              }`}
            >
              {step.label}
            </span>
          </Fragment>
        ))}
      </div>
      <div className="mt-2 text-[9.5px] text-muted">
        {t("orderingSettings.illustrationTableFlow")}
      </div>
    </div>
  );
}
